import { computed, reactive } from "vue"

const TICK_PERIOD = 1000 // 1 second

export default function () {
    let timer_id: null | ReturnType<typeof setInterval> = null

    const state = reactive({
        left_time: 0,
    })

    function tick() {
        if (state.left_time <= 0) {
            if (!timer_id) return

            clearInterval(timer_id)
            state.left_time = 0

            return
        }

        --state.left_time
    }

    function start(seconds: number) {
        state.left_time = seconds
        timer_id = setInterval(tick, TICK_PERIOD)
    }

    function stop() {
        if (!timer_id) return
        clearInterval(timer_id)
    }

    function clear() {
        stop()
        state.left_time = 0
    }

    function proceed() {
        start(state.left_time)
    }

    const isTimerActive = computed(() => Boolean(state.left_time))

    return { state, start, stop, clear, proceed, isTimerActive }
}